import { TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";

export class SceneContainer extends PIXI.Container {

    public FadeIn(): void {
        TweenLite.from(this, 1, {pixi: {alpha: 0}});
        this.visible = true;
    }

    public FadeOut(): void {
        this.interactive = false;
        new TimelineLite().to(this, 1, {pixi: {alpha: 0}}).call(()=>{
            this.visible = false;
        })
    }
}